import { render, staticRenderFns } from "./BookingSummaryAndMessaging.vue?vue&type=template&id=fe0b61e2&scoped=true&"
import script from "./BookingSummaryAndMessaging.vue?vue&type=script&lang=js&"
export * from "./BookingSummaryAndMessaging.vue?vue&type=script&lang=js&"
import style0 from "./BookingSummaryAndMessaging.vue?vue&type=style&index=0&id=fe0b61e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0b61e2",
  null
  
)

export default component.exports